<template>
	<m-slide-up :show="show" @close="$emit('close')">

		<div class="space-y-4 px-7 flex flex-col min-h-[50vh]" v-if="attendance">
			<h1 class="font-bold text-lg">Sacrament Attendance</h1>
			<div class="grid grid-cols-2 gap-3 ">
				<m-form-group aria-label="Expected Attendance" name="expectedAttendance" label="Expected Attendance">
					<input v-model="attendance.total_number_of_attendees" type="number"
						class="border border-gray-1 w-full p-2 placeholder:italic" placeholder="0" />
				</m-form-group>

				<m-form-group aria-label="Total Attendance" name="totalAttendance" label="Total Attendance">
					<input v-model="attendance.number_of_attendees" type="number"
						class="border border-gray-1 w-full p-2 placeholder:italic" placeholder="0" />
				</m-form-group>

				<m-form-group aria-label="Ward" name="ward" label="Ward">
					<m-search-pop-list :value="selectedWard"
						@change="(data) => attendance.ward = data.value.site_domain"
						@input="(text) => searchWardString = text" :searchList="filteredWards"
						searchWrapperClass="border" inputClass="w-full" class="w-full border"
						placeholder="Search ward" />
				</m-form-group>

				<m-form-group aria-label="Date" name="date" label="Date">
					<m-date-picker class="!w-full "
						inputClass="!text-gray-1 sacramentDate p-2  mx-input  shadow-none !w-full" :key="'date'"
						:value.sync="attendance.date_attendance" placeholder="MM/DD/YYYY"
						@change="(date) => attendance.date_attendance = DateUtils.dateFormat({ date, format: 'MM/DD/YYYY', timeZone: false })" />
				</m-form-group>
			</div>

			<button @click="() => $emit('change', attendance)" class="btn-secondary mt-auto my-4 w-full">
				<span 
                  v-if="isProcessing"
                  class="loader"></span>
              
              <template v-else>
                  {{ attendance?.id ?
				'Update Record' : 'Add Record' }}
              </template>
			</button>

		</div>


	</m-slide-up>
</template>

<script setup>
import { ref, computed, defineProps, defineExpose } from 'vue';
import DateUtils from '@/helpers/dateUtls';

/* ========= PROPS ====== */
const props = defineProps({
	show: { type: Boolean, default: false },
	wards: { type: Array, default: () => [] },
	attendanceList : { type: Array, default: () => [] },
})

/* ======== STATES ======= */
const searchWardString = ref('');
const attendance = ref(null)
const isProcessing = ref(false)

/* ========== COMPUTED ======== */

/**
 * Filter wards based on search string
 * remove ward that has record for the selected date
 */
const filteredWards = computed(() => {
	if (searchWardString.value) {
		return props.wards
			.filter(ward => ward.header.toLowerCase().includes(searchWardString.value.toLowerCase()))
			.filter(ward => {
				return !props.attendanceList.some(item => {
					console.log('item',ward.site_domain, item, DateUtils.isSame({date: item.date_of_attendance, compareDate: attendance.value?.date_attendance, unit: 'day', timeZone: false, dateOriginFormat: 'DD/MM/YYYY', compareDateOriginFormat: 'MM/DD/YYYY'}))
					return DateUtils.isSame({date: item.date_of_attendance, compareDate: attendance.value?.date_attendance, unit: 'day', timeZone: false, dateOriginFormat: 'DD/MM/YYYY', compareDateOriginFormat: 'MM/DD/YYYY'}) &&
						item.attendance_report.some(at => at.select_ward.value == ward.site_domain);
				})
			})
			.map(ward => {
				return {
					label: ward.header,
					value: ward
				}
			});
	}
	return [];
})


/**
 * Get selected ward label
 */
const selectedWard = computed(() => {
	if (attendance.value?.ward) {
		const ward = props.wards.find(ward => ward.site_domain == attendance.value?.ward);
		return ward ? ward.header : '';
	}
	return '';
})

/* =========== METHDOS ======== */
/**
 * Set local attendance state
 * @param {Object} data - attendance
 */
const setAttendance = (data) => {
	console.log('setAttendance', data)
	attendance.value = data
}

/**
 * Toggle processing state
 * @param {Boolean} state - processing state
 */
const toggleProcessing = (state) => {
	isProcessing.value = state;
}


/* ====== EXPOSED TO PARENT ====== */
defineExpose({
	setAttendance,
	toggleProcessing
})


</script>
